import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-cpl-submit',
  templateUrl: './cpl-submit.component.html',
  styleUrl: './cpl-submit.component.css'
})
export class CplSubmitComponent {
  @Input() taskTitle: string;
  @Input() taskDescription: string;
  @Input() taskState: string;
  @Input() canEdit: boolean = true;
  @Output() submitaction = new EventEmitter<string>();

  constructor() {
    // Initialization logic can go here
  }

  submitAction() {
    this.submitaction.emit();
  }
}
